import h from "../services/h";
import errorMessageFilter from "../filters/errorMessageFilter";
import constants from "../constants";

export default {
  methods: {
    handleRequestError(error) {
      this.notify("Lỗi", errorMessageFilter(error), "error", 3000);
      return true;
    },

    buildErrorMessage_(error) {
      return errorMessageFilter(error);
    },

    unknownErrorMessage() {
      return "Lỗi không xác định";
    },

    buildErrorMessages(error) {
      if (error.response && error.response.data) {
        let status = error.response.data.status;
        switch (status) {
          case constants.HTTP_STATUS.FORBIDDEN:
            let errorMessage = errorMessageFilter({
              errorCode: error.response.data.message || "error.default.403"
            });
            this.notify("Lỗi", errorMessage, "error", 2000);
            break;
          default:
            let error_ = error.response.data;
            if (error_.message === "BusinessErrorException") {
              if (error_.errors[0].errorCode === "signCA.error") {
                if (error_.errors[0].params[0].includes('Read timed out')) {
                  this.notify("Lỗi", "Thời gian ký đã hết hạn, vui lòng thực hiện ký lại!", "error", 2000);
                }
              } else if (error_.errors[0].errorCode === "LOCKED_DOCUMENT") {
                this.notify("Lỗi", "Văn bản đang được xử lý. Vui lòng thử lại sau!", "error", 2000);
              } else {
                return h.collect(error_.errors, item => this.buildErrorMessage_(item) || this.unknownErrorMessage());
              }
            } else {
              return [this.unknownErrorMessage()];
            }
        }
      }
      return [];
    },

    commonHandleRequestError(error) {
      let errorMessages = this.buildErrorMessages(error);
      h.each(errorMessages, errorMessage => this.notify("Lỗi", errorMessage, "error", 2000));
      return error;
    },

    getMessageError(error) {
      if (!error.response) {
        this.notify("Lỗi", this.unknownErrorMessage(), "error", 2000);
      } else {
        h.each(error.response.data, (item) => {
          if (!this.handleRequestError(item)) {
            this.notify("Lỗi", this.unknownErrorMessage(), "error", 2000);
          }
        });
      }
      return error;
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/handleRequestErrorMixin.js